<template>
  <v-card :loading="currentUpfrontCostsLoading" class="align-stretch" height="100%">
    <v-card-title>
      Upfront Costs
      <template v-if="!currentUpfrontCostsLoading">
        <v-spacer></v-spacer>
        <v-btn color="secondary" x-small @click="openEditItemsDialog" :disabled="disableEditItems"><v-icon small>edit</v-icon> EDIT ITEMS</v-btn>
        <v-btn color="secondary" x-small class="ml-2" @click="openAdhocUpfrontCosts" :disabled="disablePreviewInvoice" :loading="loadingInvoice">PREVIEW INVOICE</v-btn>
      </template>
    </v-card-title>
    <v-card-text v-if="!currentUpfrontCostsLoading">
      <v-data-table :headers="headers" :items="getCurrentUpfrontCosts" hide-default-footer>
        <template v-slot:item.description="{ item }"><span class="body--text">{{ item.description }}</span></template>
        <template v-slot:item.option="{ item }"><span class="body--text">{{ item.option }}</span></template>
        <template v-slot:item.quantity="{ item }"><span class="body--text">{{ item.quantity }}</span></template>
        <template v-slot:item.unitprice="{ item }"><span class="body--text">{{ item.unitprice }}</span></template>
        <template v-slot:item.subtotal="{ item }"><span class="body--text">{{ item.subtotal }}</span></template>
      </v-data-table>
    </v-card-text>
    <v-card-text v-if="this.currentProduct.product_kind.toLowerCase()==='telco'">
      Upfront telco hardware (eg. modems) will be ordered 4 days before the expected live date
    </v-card-text>
    <AdhocEditItemsDialog :saveType="'upfront'" :dialogOpen="editItemsDialogOpen" @close-dialog="editItemsDialogOpen=false"/>
  </v-card>
</template>

<script>
  import AdhocEditItemsDialog from './../Adhoc/AdhocEditItemsDialog';
  import { mapState,mapActions,mapGetters,mapMutations } from 'vuex';

  export default {
    components: { AdhocEditItemsDialog },

    data() {
      return {
        pid:'',
        editItemsDialogOpen:false,
        loadingInvoice:false,
        headers: [
          {text: "Description",sortable: false,value: "description"},
          {text: "Option",sortable: false,value: "option"},
          {text: "Quantity",sortable: false,value: "quantity"},
          {text: "Unit Price",sortable: false,value: "unitprice"},
          {text: "Subtotal",sortable: false,value: "subtotal"},
        ],
      }
    },
    
    computed: {
      ...mapState('products',['currentProduct']),
      ...mapState('upfrontcosts',['currentUpfrontCostsLoading']),
      ...mapGetters('upfrontcosts',['getCurrentUpfrontCosts','getCurrentUpfrontCostIds']),
      ...mapGetters('adhoc',['getAdhocLineItems']),
      ...mapGetters('products', ['getCurrentProduct']),

      disableEditItems() {
        return this.getCurrentProduct.status !== 'Warm';
      },

      disablePreviewInvoice() {
        return this.loadingInvoice || this.getCurrentProduct.status !== 'Warm';
      }
    },

    methods: {
      ...mapActions('upfrontcosts',['fetchUpfrontCostsById']),
      ...mapActions('adhoc',['fetchAdhocLineItems']),
      ...mapActions('alerts', ['setAlert']),
      ...mapMutations('adhoc',['setCurrentAdhocInvoiceLineItems','setIsUpfrontCosts','setAdhocCreateInvoiceOpen']),
      openEditItemsDialog() {
        this.editItemsDialogOpen=true;
      },
      async openAdhocUpfrontCosts(){
        this.setIsUpfrontCosts(true);
        this.loadingInvoice = true;
        if(this.getAdhocLineItems().length===0){
          await this.fetchAdhocLineItems(this.currentProduct.product_kind.toLowerCase());
        }
        let items = [];
        let ids = this.getCurrentUpfrontCostIds.map(e=>{return e.id;});
        this.getAdhocLineItems().forEach(cat => {
          if(cat.hasGroups){
            Object.keys(cat.groups).forEach(k => {
              let group = cat.groups[k];
              group.items.forEach(item => {
                let index = ids.indexOf(item.id);
                if(index!==-1){
                  item.cat = cat.name;
                  item.quantity = this.getCurrentUpfrontCostIds[index].quantity;
                  items.push(item);
                }
              });
            });
          }
          cat.items.forEach(item => {
            let index = ids.indexOf(item.id);
            if(index!==-1){
              item.cat = cat.name;
              item.quantity = this.getCurrentUpfrontCostIds[index].quantity;
              items.push(item);
            }
          });
        });
        this.setCurrentAdhocInvoiceLineItems(items);
        this.setAdhocCreateInvoiceOpen(true);
        this.loadingInvoice = false;
      },
    },
    async mounted () {
      this.pid = this.currentProduct.id;
      await this.fetchUpfrontCostsById(this.pid);
    },
  }
</script>

<style lang="scss" scoped></style>
